import { replaceDoubleSlashWithSingleSlash } from "./stringReplacement";
export const cleanPath = (path, badPathReturn) => {
    const res = path.trim();
    if (typeof badPathReturn !== undefined && (res === "" || res === "/"))
        return badPathReturn;
    return replaceDoubleSlashWithSingleSlash(res);
};
export const cleanPathForURL = (path) => encodeURIComponent(cleanPath(path) ?? "");
